import * as React from 'react';
import { Form, Input, Dropdown, Button } from 'semantic-ui-react';
import { DurationFromType } from 'src/services/graphql/Models';

const fromTypeOptions = [
    {
        value: DurationFromType.minute,
        text: 'min'
    },
    {
        value: DurationFromType.hour,
        text: 'hrs'
    },
    {
        value: DurationFromType.days,
        text: 'days'
    }
];

const actionableFromTypeOptions = [
    {
        value: DurationFromType.sinceAction,
        text: 'from action'
    },
    ...fromTypeOptions
];

function getFromInput(value: any, options: any, change: any) {
    return (
        <Dropdown
            value={value}
            options={options}
            name="durationFromType"
            onChange={change}
        />
    );
}

export  default function getDurationOptions(
    { durationFromType, durationFrom}: any, 
    changeHandler: any, 
    actions?: any[]
) {
    const buttonGroups = (
        <Button.Group>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.hour
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '1'
                    });
                }}
            >An Hour
            </Button>
            
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.hour
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '6'
                    });
                }}
            >Six Hour
            </Button>

            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.hour
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '12'
                    });
                }}
            >Twelve Hour
            </Button>

            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '1'
                    });
                }}
            >A Days
            </Button>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '3'
                    });
                }}
            >Three Days
            </Button>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '7'
                    });
                }}
            >A Week
            </Button>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '15'
                    });
                }}
            >Fortnite
            </Button>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '30'
                    });
                }}
            >A Month
            </Button>
            <Button 
                type="button"
                onClick={() => {
                    changeHandler(null, {
                        name: 'durationFromType',
                        value: DurationFromType.days
                    });
                    changeHandler(null, {
                        name: 'durationFrom',
                        value: '365'
                    });
                }}
            >A Year
            </Button>
        </Button.Group>
    );
    if (actions && actions.length > 0) {
        const actionableLabel = getFromInput(durationFromType, actionableFromTypeOptions, changeHandler);
        if (durationFromType === DurationFromType.sinceAction) {
            return (
                <div>
                    <Form.Field>
                        <label>From Duration</label>
                        {buttonGroups}
                        <Dropdown
                            options={actions.map(action => { return {
                                key: action.alias,
                                text: action.alias,
                                value: action.alias
                            }; })}
                            name="durationFrom"
                            value={durationFrom}
                            onChange={changeHandler}
                            label={actionableLabel}
                            labelPosition="left"
                        />
                    </Form.Field>
                </div>
            );
        } else {

            return (
                <Form.Field>
                    <label>From Duration</label>
                    {buttonGroups}
                    <Input 
                        name="durationFrom"
                        value={durationFrom}
                        onChange={changeHandler}
                        label={actionableLabel}
                        labelPosition="left"
                    />
                </Form.Field>
            );
        }

    } else {
        return (
            <Form.Field>
                <label>From Duration</label>
                {buttonGroups}
                <Input 
                    name="durationFrom"
                    value={durationFrom}
                    onChange={changeHandler}

                    label={getFromInput(durationFromType, fromTypeOptions, changeHandler)}
                    labelPosition="left"
                />
            </Form.Field>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/inputs/DurationInput.tsx